import React, { useState } from "react";
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TableSortLabel,
  Pagination,
} from "@mui/material";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import EditLocationIcon from "@mui/icons-material/EditLocation";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import JumboDdMenu from "@jumbo/components/JumboDdMenu";
import { displayDateFun } from "app/utils/constants/functions";
import { useEffect } from "react";
import Swal from "sweetalert2";
import ChangeLocation from "../ActionComponent/changeLocation";
import {
  getAllFinishedGoods,
  getAllFinishedScrapped,
} from "app/redux/actions/inventoryAction";
import axios from "axios";
import FullScreenLoader from "app/components/ListingPageLoader";

export default function FinishedGoodsTable({ searchTerm }) {
  const [order, setOrder] = useState("");
  const [orderBy, setOrderBy] = useState("fabric_code");
  const [page, setPage] = useState(1);
  const [isInfoModalOpen, setInfoModalOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const { finishedGoods, error, TotalPage, loading } = useSelector(
    (state) => state.inventoryReducer
  );
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSort = (property) => {
    const isAscending = orderBy === property && order === "asc";
    setOrder(isAscending ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = finishedGoods?.sort((a, b) => {
    let aValue;
    let bValue;
    // console.log(orderBy);
    if (orderBy == "supplier_master.supplier_name") {
      aValue = a.supplier_master.supplier_name.toLowerCase();
      bValue = b.supplier_master.supplier_name.toLowerCase();
    } else if (orderBy == "finish_good_inventory.finished_invoice_no") {
      aValue = a.finish_good_inventory.finished_invoice_no.toLowerCase();
      bValue = b.finish_good_inventory.finished_invoice_no.toLowerCase();
    } else if (orderBy == "finish_good_inventory.finished_invoice_value") {
      aValue = a.finish_good_inventory.finished_invoice_value;
      bValue = b.finish_good_inventory.finished_invoice_value;
    } else if (orderBy == "purchase_order.purchase_order_no") {
      aValue = a.purchase_order.purchase_order_no.toLowerCase();
      bValue = b.purchase_order.purchase_order_no.toLowerCase();
    } else if (orderBy == "finished_item_name") {
      aValue = a.finished_item_name.toLowerCase();
      bValue = b.finished_item_name.toLowerCase();
    } else if (orderBy == "finished_size") {
      aValue = a?.finished_size?.toLowerCase();
      bValue = b?.finished_size?.toLowerCase();
    } else {
      aValue = a[orderBy];
      bValue = b[orderBy];
    }

    if (order === "desc") {
      return aValue < bValue ? -1 : 1;
    } else {
      return bValue < aValue ? -1 : 1;
    }
  });

  const handleItemAction = (menuItem) => {
    switch (menuItem.action) {
      case "manuallyIssue":
        navigate("/dashboard/inventory/manuallyIssue", {
          state: {
            menuItemData: menuItem.data,
            type: "Finished Goods",
          },
        });
        break;
      case "finishedscrapped":
        addToScrap(menuItem.data.id);
        break;
      case "changeLocation":
        setInfoModalOpen(true);
        setSelectedRowData(menuItem.data);
        break;
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(getAllFinishedGoods(searchTerm, "", newPage));
  };

  useEffect(() => {
    if (error == "No finished Goods Inventory found") {
      Swal.fire({ icon: "error", title: "No Result Found" });
    }
  }, [error]);

  const addToScrap = (id) => {
    const config = {
      withCredentials: true,
      headers: {
        withCredentials: true,
      },
    };
    const data = {
      finished_item_type: "Finished Scrapped Inventory",
    };
    axios
      .patch(
        `${process.env.REACT_APP_URL}/api/finished-item/add-to-scrap_finished?id=${id}`,
        data,
        config
      )
      .then((res) => {
        if (res?.status == 200) {
          Swal.fire({ icon: "success", title: "Added To Scrap" });
          dispatch(getAllFinishedGoods("", ""));
        }
      });
  };

  return (
    <>
      {" "}
      {loading && <FullScreenLoader />}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: "#202020", color: "white" }}>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "145px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={
                    orderBy === "finish_good_inventory.finished_invoice_no"
                  }
                  direction={order}
                  onClick={() =>
                    handleSort("finish_good_inventory.finished_invoice_no")
                  }
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Invoice No.
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "145px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={
                    orderBy === "finish_good_inventory.finished_invoice_value"
                  }
                  direction={order}
                  onClick={() =>
                    handleSort("finish_good_inventory.finished_invoice_value")
                  }
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Invoice Value
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "145px",
                  verticalAlign: "middle",
                  color: "white",
                }}
              >
                Invoice Date
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "145px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "finished_item_name"}
                  direction={order}
                  onClick={() => handleSort("finished_item_name")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Item Name
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "145px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "finished_size"}
                  direction={order}
                  onClick={() => handleSort("finished_size")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Size
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "145px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "finished_item_recieved_quantity"}
                  direction={order}
                  onClick={() => handleSort("finished_item_recieved_quantity")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Received Quantity
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "145px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "return_quantity"}
                  direction={order}
                  onClick={() => handleSort("return_quantity")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Return Quantity
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "145px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "finished_item_reserve_quantity"}
                  direction={order}
                  onClick={() => handleSort("finished_item_reserve_quantity")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Available Quantity
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "145px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "finished_rack_details"}
                  direction={order}
                  onClick={() => handleSort("finished_rack_details")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Rack Details
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "145px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "purchase_order.purchase_order_no"}
                  direction={order}
                  onClick={() => handleSort("purchase_order.purchase_order_no")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  PO No.
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "145px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "supplier_master.supplier_name"}
                  direction={order}
                  onClick={() => handleSort("supplier_master.supplier_name")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Supplier Name
                </TableSortLabel>
              </TableCell>
              {permissions?.inventory_edit == true && (
                <TableCell
                  sx={{
                    textAlign: "left",
                    minWidth: "95px",
                    verticalAlign: "middle",
                    color: "white",
                    px: 1,
                    position: "sticky",
                    right: 0,
                    height: "58px",
                    zIndex: 1,
                    bgcolor: "#202020",
                  }}
                >
                  Action
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData?.map((row, i) => (
              <TableRow key={i}>
                <TableCell sx={{ textAlign: "left" }}>
                  {row?.finish_good_inventory.finished_invoice_no}
                </TableCell>
                <TableCell sx={{ textAlign: "left" }}>
                  {row?.finish_good_inventory.finished_invoice_value}
                </TableCell>
                <TableCell sx={{ textAlign: "left" }}>
                  {row?.finish_good_inventory.finished_invoice_date == null
                    ? "N/A"
                    : displayDateFun(
                        row?.finish_good_inventory.finished_invoice_date
                      )}
                </TableCell>
                <TableCell sx={{ textAlign: "left" }}>
                  {row?.finished_item_name}
                </TableCell>
                <TableCell sx={{ textAlign: "left" }}>
                  {row?.finished_size ? row?.finished_size : "-"}
                </TableCell>
                {/* {console.log(row)} */}
                <TableCell sx={{ textAlign: "left" }}>
                  {row?.finished_item_recieved_quantity}
                </TableCell>
                <TableCell sx={{ textAlign: "left" }}>
                  {row?.return_quantity}
                </TableCell>
                <TableCell sx={{ textAlign: "left" }}>
                  {row?.finished_item_reserve_quantity}
                </TableCell>
                <TableCell sx={{ textAlign: "left" }}>
                  {row?.finished_rack_details}
                </TableCell>
                <TableCell sx={{ textAlign: "left" }}>
                  {row?.purchase_order?.purchase_order_no}
                </TableCell>
                <TableCell sx={{ textAlign: "left" }}>
                  {row?.supplier_master?.supplier_name}
                </TableCell>
                {permissions?.inventory_edit == true && (
                  <TableCell
                    sx={{
                      textAlign: "left",
                      px: 1,
                      position: "sticky",
                      right: 0,
                      zIndex: 1,
                      bgcolor: "white",
                    }}
                  >
                    <JumboDdMenu
                      icon={<MoreHorizIcon />}
                      menuItems={[
                        {
                          icon: <EditLocationIcon />,
                          title: "Change Location",
                          action: "changeLocation",
                          data: row,
                        },
                        {
                          icon: <MiscellaneousServicesIcon />,
                          title: "Add To Scrap",
                          action: "finishedscrapped",
                          data: row,
                        },
                        {
                          icon: <AddCircleOutlineIcon />,
                          title: "Manually Issue",
                          action: "manuallyIssue",
                          data: row,
                        },
                      ]}
                      onClickCallback={handleItemAction}
                    />
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
          <ChangeLocation
            open={isInfoModalOpen}
            onClose={() => setInfoModalOpen(false)}
            rowData={selectedRowData}
            type={"finishedGoods"}
          />
        </Table>
        <Pagination
          count={TotalPage || 1} // Replace with the actual total number of pages
          page={page}
          onChange={handleChangePage}
          sx={{
            position: "sticky",
            bottom: 0,
            left: 0,
            backgroundColor: "white",
            borderTop: "1px solid #ddd",
          }}
        />
      </TableContainer>
    </>
  );
}
